import etherscanLikeApi from "./etherscan";
/**
 * Switch to select one of the compatible explorer
 */
export const getExplorerApi = (currency) => {
    var _a, _b;
    const apiType = (_b = (_a = currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.explorer) === null || _b === void 0 ? void 0 : _b.type;
    switch (apiType) {
        case "etherscan":
        case "blockscout":
        case "teloscan":
            return etherscanLikeApi;
        default:
            throw new Error(`No explorer found for currency "${currency.id}"`);
    }
};
//# sourceMappingURL=index.js.map